<template>
  <div class="content">
    <h1 class="has-text-centered">Online Ressourcen um Elektrotechnik zu lernen</h1>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/screenshots/elektronik-kompendium.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">Elektronik Kompendium</h2>
          <div class="tags">
            <span class="tag">Deutsch</span>
          </div>
          <p>
            Elektronik, Computertechnik, Kommunikationstechnik und Netzwerktechnik einfach und leicht verständlich erklärt.
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="https://www.elektronik-kompendium.de/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/screenshots/studyflix.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">studyflix</h2>
          <div class="tags">
            <span class="tag">Deutsch</span>
          </div>
          <p>
            Schriftliche Erklärungen und Videos zu Grundlagen, Regelungstechnik, Digitaltechnik, Elektromotoren und vielem mehr.
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="https://studyflix.de/elektrotechnik/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/screenshots/elektroniktutor.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">Elektroniktutor</h2>
          <div class="tags">
            <span class="tag">Deutsch</span>
          </div>
          <p>
            Dieses Webprojekt stellt allen Interessierten grundlegende und weiterführende Informationen rund um die Elektronik zur Verfügung.
          </p>

          <p class="has-text-centered">
            <a class="button is-primary" href="https://www.elektroniktutor.de/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/screenshots/die-elektronikerseite.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">Die Elektronikerseite</h2>
          <div class="tags">
            <span class="tag">Deutsch</span>
          </div>
          <p>
            Eine Seite für Elektroniker mit Datenblättern, Tabellen, Downloads, Kurse, Lehrgänge, Formeln, Bauteile, Buchempfehlungen ...
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="http://www.dieelektronikerseite.de/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/screenshots/open-source-curriculum.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">Open-Source Electrical Engineering Curriculum</h2>
          <div class="tags">
            <span class="tag">Englisch</span>
          </div>
          <p>
            Ein zusammengestelltes Curriculum mit (fast) allen notwendigen Ressourcen für ein Selbststudium.
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="https://github.com/Artoriuz/OSEE" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-half has-text-centered">
          <img class="max-width-280 screenshot" src="@/assets/images/screenshots/edx.png">
        </div>
        <div class="column is-half is-size-7-mobile">
          <h2 class="is-size-4-mobile">edX.org</h2>
          <div class="tags">
            <span class="tag">Englisch</span>
          </div>
          <p>
            Ein riesiges Angebot an kostenlosen Online-Kursen von Universitäten rund um die Welt. Das Angebot ist nicht auf Elektrotechnik beschränkt. Hier kannst du deinen Wissensdurst in fast jede Richtung stillen.
          </p>
          <p class="has-text-centered">
            <a class="button is-primary" href="https://www.edx.org/" target="_blank">Webseite öffnen</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ee-learning',
  metaInfo: {
    title: 'Elektrotechnik einfach online lernen',
    meta: [
      {
        name: 'description',
        content: 'Du möchtest Elektrotechnik lernen? Hier findest du einige Links zu Online Ressourcen, die dir dabei helfen werden.'
      }
    ]
  },
  created () {
    this.$store.commit('updateNavTitle', { title: 'Lernen', route: 'start' })
  }
}
</script>
